export const heroSlides = [
  {
    id: "m001",
    title: "星际回声",
    meta: "2024 · 科幻 / 冒险 · 美国",
    desc: "深空探测队捕获神秘回声，人类的起源之谜随之被揭开。",
    tag: "最新上线",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20scene%20of%20a%20lone%20astronaut%20floating%20before%20a%20vast%20glowing%20nebula%20and%20a%20distant%20ringed%20planet%2C%20deep%20blue%20and%20violet%20space%20tones%20with%20warm%20orange%20rim%20lighting%2C%20dramatic%20and%20moody%20atmosphere%2C%20highly%20detailed%20film%20key%20art%2C%20no%20text%2C%20no%20watermark%2C%20no%20logo&width=1600&height=900&seq=hero-mv-01&orientation=landscape",
  },
  {
    id: "m003",
    title: "王冠与灰烬",
    meta: "2024 · 剧情 / 历史 · 英国",
    desc: "在动荡年代，一位年轻的王位继承人在权谋与信仰之间挣扎前行。",
    tag: "高分剧集",
    backdrop:
      "https://readdy.ai/api/search-image?query=Grand%20cinematic%20wide%20scene%20of%20a%20regal%20figure%20in%20a%20dark%20velvet%20cloak%20standing%20in%20a%20candlelit%20stone%20hall%20with%20tall%20arched%20windows%2C%20golden%20ember%20glow%20and%20deep%20shadows%2C%20historical%20period%20drama%20key%20art%2C%20rich%20contrast%2C%20no%20text%2C%20no%20watermark%2C%20no%20logo&width=1600&height=900&seq=hero-mv-02&orientation=landscape",
  },
  {
    id: "m002",
    title: "暗夜追缉",
    meta: "2023 · 犯罪 / 惊悚 · 美国",
    desc: "一名坚持原则的老警探在雨夜追踪连环案件，真相却指向他最信任的人。",
    tag: "热门推荐",
    backdrop:
      "https://readdy.ai/api/search-image?query=Neo%20noir%20cinematic%20wide%20scene%20of%20a%20lone%20detective%20standing%20under%20heavy%20rain%20in%20a%20dark%20city%20alley%20with%20neon%20reflections%20on%20wet%20asphalt%2C%20high%20contrast%20shadows%20and%20warm%20amber%20highlights%2C%20gritty%20crime%20thriller%20key%20art%2C%20no%20text%2C%20no%20watermark%2C%20no%20logo&width=1600&height=900&seq=hero-mv-03&orientation=landscape",
  },
  {
    id: "m005",
    title: "北境迷雾",
    meta: "2023 · 悬疑 / 犯罪 · 英国",
    desc: "苏格兰高地的雾夜里接连发生失踪案，一位女警探揭开了小镇尘封的秘密。",
    tag: "口碑佳作",
    backdrop:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20wide%20scene%20of%20a%20misty%20Scottish%20highland%20landscape%20at%20dusk%20with%20a%20small%20stone%20town%20and%20a%20distant%20lone%20figure%2C%20cool%20grey%20tones%20with%20a%20single%20warm%20window%20light%2C%20mystery%20series%20key%20art%2C%20moody%20and%20layered%2C%20no%20text%2C%20no%20watermark%2C%20no%20logo&width=1600&height=900&seq=hero-mv-04&orientation=landscape",
  },
  {
    id: "m004",
    title: "沉默航班",
    meta: "2024 · 惊悚 / 悬疑 · 美国",
    desc: "一架跨洋航班在万米高空失去联络，乘客们发现真正的威胁来自机舱之内。",
    tag: "悬疑新片",
    backdrop:
      "https://readdy.ai/api/search-image?query=Tense%20cinematic%20wide%20scene%20inside%20an%20airplane%20cabin%20at%20night%20with%20storm%20clouds%20outside%20the%20windows%20and%20a%20silhouette%20of%20a%20passenger%20in%20the%20aisle%2C%20cold%20steel%20and%20amber%20lighting%2C%20claustrophobic%20thriller%20key%20art%2C%20high%20contrast%2C%20no%20text%2C%20no%20watermark%2C%20no%20logo&width=1600&height=900&seq=hero-mv-05&orientation=landscape",
  },
];